module.exports = __webpack_public_path__ + "img/logo500blue.9f9b906c.png";